import React, {useState, useEffect } from "react"
import { Routes, Route, Navigate } from "react-router-dom"
import { apiRoot, server } from './ApiConfig'
import axios from "axios"
import Activate from './Activate'
import PasswordChange from './passwordChange'
import Menu from './Menu'
import Login from './Login'
//import { apiPort } from './ApiConfig'
import { useGlobal } from './GlobalContext'
import { useT } from './i18n/LanguageContext'
import './App.css'

const App = () => {
  const t = useT()
  //localStorage eleinek kiírása
  /*for (let i = 0; i < localStorage.length; i++) {
    const key = localStorage.key(i)
    const value = localStorage.getItem(key)
    console.log('localStorage '+`${key}: ${value}`)
  }*/

  // event for back/forward navigation:
  /*let lastPath = window.location.pathname
  window.addEventListener('popstate', (event) => {
    window.__lastNavigation = {
      from: lastPath,
      to: window.location.pathname,
      state: event.state
    }
    lastPath = window.location.pathname
  })*/

  const [isCheckingSession, setIsCheckingSession] = useState(true)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [sessionId, setSessionId] = useState(false)
  const [userEmail, setUserEmail] = useState(false)
  const [userPassword, setUserPassword] = useState(false)
  const [userAdmin, setUserAdmin] = useState("")

  //const { adminWatch, setAdminWatch  } = useGlobal()
  const { backToUserManagement, setBackToUserManagement  } = useGlobal()
  const { userRole, setUserRole, setWorkflowRoles } = useGlobal()

  useEffect(() => {
    document.title = "VoxDoc " + server
    const onPopState = () => {
      if (window.location.pathname === "/menu/user-management") {
        console.log("Browser back gombbal érkeztem a UserManagement-be")
        setBackToUserManagement(true)
        // ide hívod a UserManagement-specifikus logikát
        // pl. egy global state vagy context segítségével
      }
    }
    window.addEventListener("popstate", onPopState)
    return () => window.removeEventListener("popstate", onPopState)
  }, [])

  useEffect(() => {
    const init = async () => {
      const lsSessionId = localStorage.getItem("sessionId")
      //console.log("sessionId---", lsSessionId)
      //console.log("adminWatch---", adminWatch)
      //console.log("isLoggedIn---", isLoggedIn)
      //console.log("lsSessionId---", lsSessionId)
  
      if (lsSessionId > "-1") {
        try {
          const response = await axios.post(apiRoot + "api/sessions/IsSessionAvailable", {
            sessionId: lsSessionId
          })
          //console.log("IsSessionAvailable", response.data)
  
          if (response.data.success && response.data.results.isIsSessionAvailable) {
            setSessionId(lsSessionId)
            setUserEmail(localStorage.getItem("email") || "")
            setUserPassword(localStorage.getItem("password") || "")
            setUserAdmin(Number(localStorage.getItem("admin")) || "")
            const savedRole = localStorage.getItem("role") || ""
            setUserRole(savedRole.trim().toLowerCase() === "corrector" ? "Transcriptionist" : savedRole)
            try {
              const wr = JSON.parse(localStorage.getItem("workflowRoles") || "[]")
              setWorkflowRoles(Array.isArray(wr) ? wr : [])
            } catch {
              setWorkflowRoles([])
            }
            setIsLoggedIn(true)
          } else {
            setIsLoggedIn(false)
          }
          //console.log("isLoggedIn",isLoggedIn)
        } catch (error) {
          console.error("Session check error", error)
          setIsLoggedIn(false)
        }
      }
      setIsCheckingSession(false) // session ellenőrzés befejezve
    }
  
    init()
  }, [])

  if (isCheckingSession) {
    return <div>{t("userui.app.loading", "Loading...")}</div>; // vagy egy spinner
  }

  return (
    <Routes>
      {/* Login és Regisztráció */}
      <Route path="/login" element={
        <div style={{ display: 'flex', height: '100vh' }}>
          <Menu
            userEmail=""
            sessionId=""
            userAdmin=""
            setSessionId={setSessionId}
            setUserEmail={setUserEmail}
            isLoginMode={true}
          />
          <Login
            setIsLoggedIn={setIsLoggedIn}
            setSessionId={setSessionId}
            setUserEmail={setUserEmail}
            setUserAdmin={setUserAdmin}
            //setUserRole={setUserRole}
            server={server}
            lsEmail={localStorage.getItem("email") || ""}
            lsPassword={localStorage.getItem("password") || ""}
          />
        </div>
      } />

      {/* Menü (csak akkor engedjük, ha be van jelentkezve) */}
      {isLoggedIn && (
        <Route path="/menu/*" element={
          <Menu
            userEmail={userEmail}
            sessionId={sessionId}
            userAdmin={userAdmin}
            setSessionId={setSessionId}
            setUserEmail={setUserEmail}
          />
        } />
      )}
      {/* Activate */}
      <Route path="/activate" element={<Activate />} />
      {/* Password Change */}
      <Route path="/passwordChange" element={<PasswordChange />} />

      {/* Redirect alapértelmezetten a /login-re EZ LEGYEN AZ UTOLSÓ ROUTE PATH !!!!!!!!!!*/}
      <Route path="*" element={<Navigate to="/login" />} />

    </Routes>
  )
}

export default App
